import React from "react";
import { Checkbox, Form, Input, InputNumber, Radio, Select } from "antd";

const { TextArea } = Input;

function ServicesGovernance({
  plainOptions,
  form,
  dataPest,
  dataExtension,
  dataValueAddition,
}) {
  const valueAdditionAvailable = Form.useWatch(
    "valueAdditionAvailable",
    form
  );

  return (
    <>
      <div className="custom-title !text-[#111928] rounded-[.5rem]">
        Services and Losses
      </div>
      <Form.Item
        name="pestIds"
        label={"Pests and Diseases Control"}
      >
        <Checkbox.Group
          options={
            dataPest?.map((item) => ({
              value: item?.pdId,
              label: item?.pdPest,
            })) ?? []
          }
        />
      </Form.Item>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
        <Form.Item
          name="extensionServiceIds"
          label={"Extension Services Available"}
        >
          <Select
            mode="multiple"
            allowClear
            placeholder="Select services"
            style={{
              width: "100%",
            }}
            options={
              dataExtension?.length > 0 &&
              dataExtension?.map((item) => ({
                value: item?.esId,
                label: item?.esProvider,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
        <Form.Item name="postHarvestLoss" label={"Post Harvest Loss (%)"}>
          <InputNumber
            min={0}
            max={100}
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            placeholder="Enter value"
            className="input flex"
          />
        </Form.Item>

        <Form.Item
          name="postHarvestLossCause"
          label={"How does the post harvest loss occur ? (Major Ones)"}
        >
          <TextArea rows={3} className="text_area" />
        </Form.Item>
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
        <Form.Item
          name="valueAdditionAvailable"
          label={"Value Addition - service providers available?"}
        >
          <Radio.Group options={plainOptions} />
        </Form.Item>
        {valueAdditionAvailable === "Yes" && (
          <Form.Item
            name="valueAdditionIds"
            label={"Type of Value Addition"}
          >
            <Select
              mode="multiple"
              allowClear
              placeholder="Select type of value addition"
              style={{
                width: "100%",
              }}
              options={
                dataValueAddition?.length > 0 &&
                dataValueAddition?.map((item) => ({
                  value: item?.vaId,
                  label: item?.vaType,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </Form.Item>
        )}
      </div>
    </>
  );
}

export default ServicesGovernance;
